import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import Checkbox from "rc-checkbox";

import CanvasActions from "../../actions/CanvasActions.js";

import "./style.css";

class Location extends Component {
  componentDidMount() {
    if (this.props.canvas.nonUS) {
      this.props.setCanvas({
        frameCost: 0,
        frameAdded: false
      });
    }
  }

  checkboxUpdate() {
    this.props.setCanvas({
      frameAdded: this.refs.complete.checked,
      frameCost: this.refs.complete.checked ? this.props.canvas.frame : 0
    });
  }

  render() {
    let products = this.props.canvas.products;

    if (products.length < 1) {
      return <span />;
    }
    return (
      <div className="size-picker">
        <div className="info">
          <p>Pick size of print </p>
          {this.props.canvas.nonUS ? (
            <div className="sizes">
              <div
                className={
                  this.props.canvas.printSize == 1 ? "size active" : "size"
                }
                onClick={() => {
                  this.props.setCanvas({
                    ...this.props.canvas,
                    printSize: 1,
                    printCost: parseInt(products[3].price)
                  });
                }}
              >
                <span>Medium £{parseInt(products[3].price)}</span>
              </div>
              <div
                className={
                  this.props.canvas.printSize == 2 ? "size active" : "size"
                }
                onClick={() => {
                  this.props.setCanvas({
                    ...this.props.canvas,
                    printSize: 2,
                    printCost: parseInt(products[1].price)
                  });
                }}
              >
                <span>Large £{parseInt(products[1].price)}</span>
              </div>
            </div>
          ) : (
            <div className="sizes">
              <div
                className={
                  this.props.canvas.printSize == 1 ? "size active" : "size"
                }
                onClick={() => {
                  this.props.setCanvas({
                    ...this.props.canvas,
                    printSize: 1,
                    printCost: parseInt(products[3].price)
                  });
                }}
              >
                <span>12 × 18 inches – ${parseInt(products[3].price)}</span>
              </div>
              <div
                className={
                  this.props.canvas.printSize == 2 ? "size active" : "size"
                }
                onClick={() => {
                  this.props.setCanvas({
                    ...this.props.canvas,
                    printSize: 2,
                    printCost: parseInt(products[1].price)
                  });
                }}
              >
                <span>18 × 24 inches – ${parseInt(products[1].price)}</span>
              </div>
            </div>
          )}

          {!this.props.canvas.nonUS && (
            <div className="info frame-pick">
              <input
                type="checkbox"
                value={this.props.frameAdded}
                defaultChecked={this.props.frameAdded}
                ref="complete"
                onChange={this.checkboxUpdate.bind(this)}
              />
              <div>
                <p>INCLUDE FRAME +$65 (US ONLY)</p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    canvas: state.canvas
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(Location);

export default App;



// WEBPACK FOOTER //
// ./src/components/PrintSize/index.js